import React from "react";
import { useNavigate } from "react-router-dom";
import "./Common_Btn.css";

const Common_Btn = ({
  text,
  link,
  onClick,
  className = "",
  type = "button",
  disabled = false, // ✅ accept disabled
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled) return; // ✅ prevent click when disabled

    if (link) {
      navigate(link);
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      type={type} // ✅ pass type
      disabled={disabled} // ✅ pass disabled
      className={`Common_Btn ${className}`}
      onClick={handleClick}
    >
      {text}
    </button>
  );
};

export default Common_Btn;
